export interface OrgPermission {
  role?: string;
  financialAccess?: string;
}

/**
 * Masks financial access exactly as `Plan/components/PlanForm` does: `Full
 * control` or `View Only` with no `financialAccess` property (rather than an
 * explicit value) is treated as `'none'`.
 */
export const resolveFinancialAccess = (
  perm?: OrgPermission
): string | undefined => {
  if (!perm) return undefined;
  const masked =
    (perm.role === 'Full control' || perm.role === 'View Only') &&
    !Object.hasOwn(perm, 'financialAccess');
  return masked ? 'none' : perm.financialAccess;
};

/** Matches the legacy sections' own `disable` rule verbatim. */
export const isFinancialFieldDisabled = (
  memberRole?: string,
  memberFinancialAccess?: string
): boolean =>
  memberRole === 'Full control' &&
  (memberFinancialAccess === 'none' || memberFinancialAccess === 'READ');
